/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useState, useMemo, useEffect, useRef } from 'react';
import { Stack } from '@mui/material';
import DialogTextField from 'components/dialog/DialogTextField';
import { useProject } from 'hooks/useProject';

interface ISurveyShortAnswerProps {
  id: string;
  type: string;
  handleNext: (_type: string, _surveyId: string, _info: any) => void;
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  surveyType: 'survey' | 'surveyAdd';
}
function SurveyShortAnswer({ id, type, handleNext, setIsDisabled, surveyType }: ISurveyShortAnswerProps): JSX.Element {
  const { progressInfo, surveyResultList, surveyInfoResultList } = useProject();
  const buttonInfo = useMemo(() => {
    const resultList = surveyType === 'surveyAdd' ? surveyResultList : surveyInfoResultList;
    return resultList?.[progressInfo]?.answerResult || '';
  }, [surveyType, surveyResultList, surveyInfoResultList, progressInfo]);

  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setValue(buttonInfo);
    inputRef.current?.focus();
  }, [buttonInfo]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };
  const handleBlur = () => {
    handleNext(type, id, value);
  };

  useEffect(() => {
    setIsDisabled(value.trim().length === 0);
  }, [setIsDisabled, value]);
  return (
    <Stack direction="column">
      <DialogTextField
        text={value}
        variant="outlined"
        name="content"
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="답변을 입력하세요"
        marginBottom="0px"
        inputRef={inputRef}
      />
    </Stack>
  );
}

export default memo(SurveyShortAnswer);
